import React from "react";
import {
  Box,
  Container,
  Typography,
  Link as MuiLink,
  Divider,
  useTheme,
} from "@mui/material";

export const Footer = () => {
  const theme = useTheme();
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.default,
        py: 4,
        mt: "auto", // Empurra o footer para o fim da página
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ mb: 4, borderColor: theme.palette.divider }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {currentYear} Nome da Empresa. Todos os direitos reservados.
          </Typography>
          <Box>
            <MuiLink href="#privacy" variant="body2" sx={{ ml: 2 }}>
              Política de Privacidade
            </MuiLink>
            <MuiLink href="#terms" variant="body2" sx={{ ml: 2 }}>
              Termos de Uso
            </MuiLink>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};
